import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

document.documentElement.classList.add("js");
Alpine.plugin(collapse);
window.Alpine = Alpine;
Alpine.start();

const header = document.querySelector("[data-site-header]");
const syncHeader = () => header?.classList.toggle("is-scrolled", window.scrollY > 24);
syncHeader();
window.addEventListener("scroll", syncHeader, { passive: true });

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

if (!reducedMotion) {
  gsap.registerPlugin(ScrollTrigger);

  const hero = document.querySelector("[data-hero-copy]");
  if (hero) {
    gsap.from(hero.children, {
      y: 32,
      duration: 0.85,
      stagger: 0.09,
      ease: "power3.out",
      delay: 0.15
    });
  }

  gsap.utils.toArray("[data-reveal]").forEach((element) => {
    gsap.from(element, {
      y: 34,
      duration: 0.8,
      ease: "power3.out",
      scrollTrigger: { trigger: element, start: "top 88%", once: true }
    });
  });

  gsap.utils.toArray("[data-image-reveal]").forEach((element) => {
    gsap.from(element, {
      scale: 1.035,
      duration: 1.05,
      ease: "power3.inOut",
      scrollTrigger: { trigger: element, start: "top 86%", once: true }
    });
  });

  gsap.utils.toArray("[data-counter]").forEach((element) => {
    const source = element.textContent.trim();
    const match = source.match(/([\d,.]+)/);
    if (!match) return;
    const numeric = Number(match[1].replace(/,/g, ""));
    if (!Number.isFinite(numeric)) return;
    const state = { value: 0 };
    const prefix = source.slice(0, match.index);
    const suffix = source.slice((match.index || 0) + match[1].length);
    gsap.to(state, {
      value: numeric,
      duration: 1.4,
      ease: "power2.out",
      scrollTrigger: { trigger: element, start: "top 90%", once: true },
      onUpdate: () => {
        element.textContent = `${prefix}${Math.round(state.value).toLocaleString()}${suffix}`;
      }
    });
  });
}
